import { render } from "./AddMotivoRechazoView.vue?vue&type=template&id=fab24dba&scoped=true"
import script from "./AddMotivoRechazoView.vue?vue&type=script&lang=js"
export * from "./AddMotivoRechazoView.vue?vue&type=script&lang=js"

import "./AddMotivoRechazoView.vue?vue&type=style&index=0&id=fab24dba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab24dba"]])

export default __exports__